import axios from 'axios';
import axiosRetry from 'axios-retry';
import { standardRetryPolicy } from './axiosRetryPolicy';
const getItemDetails = (baseUrl, accessToken, itemId) => {
    const url = `/v1/items/${itemId}`;
    const client = axios.create();
    axiosRetry(client, standardRetryPolicy);
    return client
        .get(url, {
        baseURL: baseUrl,
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    })
        .then(response => response.data)
        .catch(() => {
        const error = new Error('We are having trouble retrieving additional information about this item.');
        error.name = 'An error has occurred.';
        throw error;
    });
};
export { getItemDetails };
//# sourceMappingURL=item-service.js.map